var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-loading",class:{ 'ui-loading__inline': _vm.inline }},[_c('span',{staticClass:"spinner-border spinner-border-sm"})])}
var staticRenderFns = []

export { render, staticRenderFns }